import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';

export const documentsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateDocument: builder.mutation<any, { documentId: number; projectId: number; data: any }>({
      query: ({ documentId, data }) => ({
        url: `/documents/${documentId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { projectId }) => [
        {
          type: ServiceTypes.PROJECTS,
          id: projectId,
        },
        {
          type: ServiceTypes.PROJECTS,
          id: 'LIST',
        },
      ],
    }),
    downloadDocumentZip: builder.mutation<Blob, { longpullId: number; fileName: string }>({
      query: ({ longpullId, fileName }) => ({
        url: `/document-build-jobs/${longpullId}/download`,
        method: 'GET',
        params: { fileName },
        headers: { 'Content-Type': 'application/zip' },
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { skipSerialization: true },
    }),
  }),
});

export const { useUpdateDocumentMutation, useDownloadDocumentZipMutation } = documentsService;
